import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/system';
import ClaraInfo from 'features/auth/components/claraInfo';
import { AuthContainer, LoginContainer,LoginStyledAuth, StyledAuth } from './index.styles';
import ClaraLoginReview from 'features/auth/components/claraLoginReview';

const AuthLayout = ({ children }) => {
    const location = useLocation();
    const isLoginRoute = location.pathname.includes("/auth/login");

    return (
        <>
            {isLoginRoute ? (
                <LoginContainer>
                    <ClaraLoginReview />
                    <LoginStyledAuth>
                        <Box className='form-container'>
                            {children}
                        </Box>
                    </LoginStyledAuth>
                </LoginContainer>
            ) : (
                <AuthContainer>
                    <ClaraInfo />
                    <StyledAuth>
                        <Box className='form-container'>
                            {children}
                        </Box>
                    </StyledAuth>
                </AuthContainer>
            )}
        </>
    );
};

export default AuthLayout;
